export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "back": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Précédent"])},
        "click_store_hint": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cliquez sur un point de vente pour voir le détail par vendeur."])},
        "export_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Exporter"])},
        "no_data_to_export": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucune donnée à exporter pour les filtres sélectionnés."])}
      },
      "en": {
        "back": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Back"])},
        "click_store_hint": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Click on a store to see the breakdown by seller."])},
        "export_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Export"])},
        "no_data_to_export": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No data to export for the selected filters."])}
      }
    }
  })
}
